






































































import Vue from "vue";

import { default as moment, Moment } from "moment-timezone";

import { currentTimestamp } from "@/api/Termine";
import { Ausgabe, Transaktion } from "@/api/Abrechnung";
import { PopoverMode } from "./MonatsabschlussEditContextMenu.vue";

export interface MonatsabschlussUpdateEvent {
  popoverMode: PopoverMode;
  tagOriginal: string;
  tag: number;
  dame: number;
  miete: number;
}

export default Vue.extend({
  name: "MonatsabschlussEditPopover",
  data() {
    return {
      // Einstellungen für Popover-Dialog
      popoverMode: "create" as PopoverMode,
      popoverTitle: "",
      monat: "",
      showPopover: false,
      tagAuswaehlbar: true,
      mieteAenderbar: true,

      // Daten
      tagOriginal: "",
      tag: 0,
      anzahlTage: 0,
      dame: 0,
      miete: 0,
      mieteEingabe: "",
      ausgabe: {} as Ausgabe,

      // Validierung
      mieteFehler: false,
      mieteWarnung: false,
    };
  },
  methods: {
    show(popoverMode: PopoverMode, tag: string, anzahlTage: number, monat: string, dame: number, miete: number) {
      this.popoverMode = popoverMode;
      this.tagOriginal = tag;
      this.tag = parseInt(tag);
      this.anzahlTage = anzahlTage;
      this.monat = monat;
      this.dame = dame;
      this.miete = miete;
      this.mieteEingabe = this.formatiereMiete(this.miete);
      this.tagAuswaehlbar = this.mieteAenderbar = true;
      this.mieteFehler = this.mieteWarnung = false;
      console.log('Formatierte Mieteinnahme: ' + this.mieteEingabe);

      switch (popoverMode) {
        case "edit":
          this.tagAuswaehlbar = (miete == 0);
          this.popoverTitle = (this.tagAuswaehlbar ? 'Mieteinnahme erfassen' : 'Mieteinnahme bearbeiten');
          break;

        case "select-date":
          this.popoverTitle = `Ausgabe auf anderen Tag verschieben`;
          this.mieteAenderbar = false;
          break;

        default:
          this.showPopover = false;
          return;
      }

      this.showPopover = true;
    },

    formatiereMiete(miete?: number) {
      return this.miete ? Math.floor(this.miete) + ',' + (""+Math.floor((this.miete * 100) % 100)).padEnd(2, '0') : "";
    },

    updateMiete(rest?: any) {
      const neueMiete = this.mieteEingabe;
      console.log(neueMiete);
      console.log(rest);
      const punktPos = neueMiete.indexOf('.');
      const kommaPos = neueMiete.indexOf(',');
      let vorkomma = neueMiete, nachkomma = "00";
      if (kommaPos < punktPos) {
        vorkomma = neueMiete.substring(0, punktPos).replaceAll(',', '');
        nachkomma = neueMiete.substring(punktPos + 1);
      } else if (kommaPos >= 0) {
        vorkomma = neueMiete.substring(0, kommaPos).replaceAll('.', '');
        nachkomma = neueMiete.substring(kommaPos + 1);
      }
      if (nachkomma.length == 1) {
        nachkomma += "0";
      }
      console.log("Berechne Miete aus " + vorkomma + " und " + nachkomma);
      let fraction = Number.parseInt(nachkomma) / 100;
      while (fraction > 1) { fraction /= 10; }
      this.miete = Number.parseInt(vorkomma) + fraction;
      this.mieteFehler = nachkomma.length != 2 || (vorkomma.length <= 1 && this.miete != 0) || this.miete < 0;
      this.mieteWarnung = this.miete < 0.5;
    },

    // Behandeln von Eingabemasken/Dialog für
    // Neuanlage/Bearbeitung/Löschung
    popoverYesSave() {

      this.showPopover = false;

      this.$emit("update", {
        popoverMode: this.popoverMode,
        tagOriginal: this.tagOriginal,
        tag: this.tag,
        dame: this.dame,
        miete: this.miete,
      } as MonatsabschlussUpdateEvent);
    },
    popoverNoAbort() {
      this.showPopover = false;
    },
  },
});
